import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';

const Hero: React.FC = () => {
  const scrollToContactForm = () => {
    const element = document.getElementById('formulario-contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };



  const scrollToServices = () => {
    const element = document.getElementById('servicos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative bg-blue-100 pt-28 pb-16 px-6 sm:px-8 md:pt-32 md:pb-20">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Conteúdo Principal */}
          <div className="space-y-10 sm:space-y-12 animate-fade-in">
            <div className="space-y-6 sm:space-y-8">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-gray-900 leading-tight md:leading-relaxed">
                Recupere sua
                <span className="text-primary-500 block">
                  Mobilidade
                </span>
                com Cuidado Personalizado
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
                Sou a <strong>Dra. Katia Honda</strong>, fisioterapeuta com foco em reabilitação músculo-esquelética. 
                Nosso desejo é ajudar pessoas a se recuperarem de dores e lesões no conforto de sua casa.
              </p>
            </div>

            {/* Benefícios principais */}
            <div className="space-y-4 sm:space-y-5">
              <div className="flex items-start space-x-4">
                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-accent-500 flex-shrink-0 mt-1" />
                <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Atendimento domiciliar personalizado</span>
              </div>
              <div className="flex items-start space-x-4">
                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-accent-500 flex-shrink-0 mt-1" />
                <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Foco em reabilitação músculo-esquelética e Pilates (Solo)</span>
              </div>
              <div className="flex items-start space-x-4">
                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-accent-500 flex-shrink-0 mt-1" />
                <span className="text-sm sm:text-base text-gray-700 leading-relaxed">Atendimento na zona sul de São Paulo (Jabaquara, São Judas, Conceição, Saúde, Vila Mariana ou regiões próximas)</span>
              </div>
            </div>

            {/* Call to Actions */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 pt-4">
              <button
                onClick={scrollToContactForm}
                className="btn-primary flex items-center justify-center space-x-2 group py-4 px-6 text-base font-semibold min-h-[48px]"
              >
                <span>Entrar em Contato</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </button>
              <button
                onClick={scrollToServices}
                className="btn-secondary flex items-center justify-center space-x-2 py-4 px-6 text-base font-semibold min-h-[48px]"
              >
                <span>Conhecer Serviços</span>
              </button>
            </div>
          </div>

          {/* Imagem/Placeholder */}
          <div className="relative animate-slide-up hidden md:block">
            <div className="relative">
              {/* Imagem de fisioterapia */}
              <div className="aspect-square rounded-2xl shadow-2xl overflow-hidden">
                <img 
                  src="/img1.png"
                  alt="Dra. Katia Honda fisioterapeuta zona sul SP - Equipamentos modernos de fisioterapia e reabilitação para tratamento domiciliar"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
  );
};

export default Hero;